module.exports = __webpack_public_path__ + "static/media/flag-hu.b35a2466.webp";